<select class="form-control"
        (ngModelChange)="onChangeCb($event)"
        [required]="required"
        [disabled]="disabled"
        [(ngModel)]="selected">
  <option [value]=""></option>
  <option *ngFor="let province of provinceOrderedOptions" [value]="province.key">{{province.value}}</option>
</select>
